import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
  Alert,
} from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { colors, TENANT_LOGO, TENANT_NAME } from '../utils/constants';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

const ApprovalPendingPage: React.FC = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {/* Logo */}
        <Box sx={{ mb: 4, textAlign: 'center' }}>
          <img 
            src={TENANT_LOGO} 
            alt={TENANT_NAME} 
            style={{ 
              height: 80, 
              width: 80,
              marginBottom: 16,
            }} 
          />
          <Typography 
            variant="h3" 
            component="h1" 
            sx={{ 
              fontWeight: 700,
              color: colors.primary,
              letterSpacing: '-1px'
            }}
          >
            {TENANT_NAME}
          </Typography>
          <Typography variant="h6" color="text.secondary">
            Storefront
          </Typography>
        </Box>

        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            width: '100%',
            borderRadius: 3,
            boxShadow: `0 8px 32px rgba(255, 0, 144, 0.15)`,
            textAlign: 'center',
          }}
        >
          <Box sx={{ mb: 3 }}>
            <HourglassEmptyIcon 
              sx={{ 
                fontSize: 64, 
                color: colors.primary,
                mb: 2
              }} 
            />
          </Box>

          <Typography variant="h4" component="h2" gutterBottom>
            Account Pending Approval
          </Typography>
          
          <Alert severity="info" sx={{ mb: 3, textAlign: 'left' }}>
            Your account is pending admin approval. You will be able to access the storefront once an administrator approves your account.
          </Alert>

          {user?.organization_event_name && (
            <Alert severity="success" sx={{ mb: 3, textAlign: 'left' }}>
              Organization/Event: <strong>{user.organization_event_name}</strong>
            </Alert>
          )}

          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            Thank you for registering! An administrator will review your account shortly. 
            You'll receive an email notification once your account has been approved.
          </Typography>

          <Box sx={{ mt: 3 }}>
            <Button
              variant="outlined"
              size="large"
              onClick={handleLogout}
              sx={{ 
                borderColor: colors.primary,
                color: colors.primary,
                '&:hover': {
                  backgroundColor: colors.primary,
                  color: '#fff',
                  borderColor: colors.primary,
                }
              }}
            >
              Return to Login
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default ApprovalPendingPage;